import { usePageTitle } from '@calendly/hooks'
import { parseQuery } from '@calendly/http-tools'
import { I18n } from '@calendly/i18n'
import { ArrowChevronLeftMiniIcon } from '@calendly/ui/components/icons'
import { PageHeader } from '@calendly/ui/components/page-header'
import { useSelector } from 'react-redux'

import { EyebrowBackButton } from 'components/page_elements'
import { isAdminOrOwnerOrGroupAdminSelector } from 'selectors/current_user'
import { workflowsOwnerNameSelector } from 'selectors/workflows'
import { appWorkflowListUrl, outlookConnectedPageUrl } from 'services/workflows/url'

const getBackToRoute = (owner, isAdminOrOwner) => {
  const queryParams = parseQuery(window.location.search)
  const { backTo } = queryParams
  switch (backTo) {
    case 'integrations':
      return outlookConnectedPageUrl
    default:
      return appWorkflowListUrl(owner, isAdminOrOwner)
  }
}

export const Header = ({ owner }) => {
  const ownerName = useSelector(workflowsOwnerNameSelector)
  const isAdminOrOwnerOrGroupAdmin = useSelector(isAdminOrOwnerOrGroupAdminSelector)
  const title = {
    team: I18n.t('publisher.workflows.workflow_templates.teams.title'),
    organization: I18n.t('publisher.admin.managed_workflows.title')
  }[owner.type] || I18n.t('publisher.workflows.workflow_templates.title')

  usePageTitle(`${title} - Calendly`)

  return (
    <PageHeader
      title={title}
      description={owner.type !== 'organization' && ownerName}
      eyebrow={(
        <EyebrowBackButton to={getBackToRoute(owner, isAdminOrOwnerOrGroupAdmin)}>
          <ArrowChevronLeftMiniIcon />
          {I18n.t('publisher.action.back')}
        </EyebrowBackButton>
      )}
    />
  )
}
